import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  PackageIcon, EditIcon, PauseIcon, PlayIcon,
  PlusIcon, RefreshIcon, EyeIcon, ReceiptIcon, AlertIcon,
} from '../../components/Icons';

const BASE  = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const token = () => localStorage.getItem('kialuga_token');

export default function MeusAnuncios() {
  const navigate = useNavigate();
  const [anuncios,   setAnuncios]   = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro,       setErro]       = useState('');
  const [sucesso,    setSucesso]    = useState('');

  useEffect(() => { carregar(); }, []);

  const carregar = async () => {
    setCarregando(true);
    try {
      const res  = await fetch(`${BASE}/fornecedor/anuncios`, {
        headers: { Authorization: `Bearer ${token()}` },
      });
      const data = await res.json();
      if (data.sucesso) setAnuncios(data.anuncios);
      else setErro(data.mensagem);
    } catch { setErro('Erro ao carregar anúncios'); }
    finally { setCarregando(false); }
  };

  const alterarEstado = async (id, estado) => {
    try {
      const res = await fetch(`${BASE}/anuncios/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type':'application/json', Authorization: `Bearer ${token()}` },
        body: JSON.stringify({ estado }),
      });
      const data = await res.json();
      if (data.sucesso) {
        setSucesso(`Anúncio ${estado === 'ativo' ? 'activado' : 'pausado'} com sucesso.`);
        setTimeout(() => setSucesso(''), 3000);
        carregar();
      } else {
        setErro(data.mensagem);
        setTimeout(() => setErro(''), 3000);
      }
    } catch { setErro('Erro ao actualizar anúncio'); setTimeout(() => setErro(''), 3000); }
  };

  const estadoCores = {
    pendente:   { bg:'#fffbeb', border:'#fde68a', cor:'#d97706', label:'Em revisão' },
    ativo:      { bg:'#f0fdf4', border:'#86efac', cor:'#16a34a', label:'Activo' },
    pausado:    { bg:'#f1f5f9', border:'#e2e8f0', cor:'#64748b', label:'Pausado' },
    rejeitado:  { bg:'#fef2f2', border:'#fecaca', cor:'#dc2626', label:'Rejeitado' },
  };

  const gradientes = [
    'linear-gradient(135deg,#fde8d8,#fed7b0)',
    'linear-gradient(135deg,#dbeafe,#bfdbfe)',
    'linear-gradient(135deg,#dcfce7,#bbf7d0)',
    'linear-gradient(135deg,#fef9c3,#fde68a)',
    'linear-gradient(135deg,#fce7f3,#fbcfe8)',
    'linear-gradient(135deg,#ede9fe,#ddd6fe)',
  ];

  return (
    <>
      <div className="topbar">
        <div>
          <div className="topbar-title">Meus Anúncios</div>
          <div className="topbar-sub">{anuncios.length} anúncios · {anuncios.filter(a=>a.estado==='ativo').length} activos</div>
        </div>
        <div className="topbar-actions">
          <button className="btn btn-outline" onClick={carregar} style={{display:'flex',alignItems:'center',gap:'6px'}}>
            <RefreshIcon size={14}/> Actualizar
          </button>
          <button className="btn btn-primary" onClick={()=>navigate('/fornecedor/publicar')} style={{display:'flex',alignItems:'center',gap:'6px'}}>
            <PlusIcon size={14}/> Novo anúncio
          </button>
        </div>
      </div>

      <div className="page-content">
        {erro    && <div style={{background:'var(--danger-bg)',border:'1px solid var(--danger-border)',borderRadius:'10px',padding:'12px 16px',marginBottom:'16px',fontSize:'13px',color:'var(--danger)',display:'flex',gap:'8px',alignItems:'center'}}><AlertIcon size={14}/>{erro}</div>}
        {sucesso && <div style={{background:'var(--success-bg)',border:'1px solid var(--success-border)',borderRadius:'10px',padding:'12px 16px',marginBottom:'16px',fontSize:'13px',color:'var(--success)'}}>{sucesso}</div>}

        {carregando ? (
          <div style={{textAlign:'center',padding:'60px',color:'var(--text-muted)'}}>A carregar anúncios...</div>
        ) : anuncios.length === 0 ? (
          <div className="card" style={{textAlign:'center',padding:'60px 20px'}}>
            <PackageIcon size={48} color='var(--border)'/>
            <div style={{fontSize:'16px',fontWeight:'600',marginBottom:'8px',marginTop:'12px'}}>Ainda não tens anúncios</div>
            <div style={{fontSize:'13px',color:'var(--text-muted)',marginBottom:'24px'}}>Publica o teu primeiro anúncio e começa a ganhar em Kz.</div>
            <button className="btn btn-primary" onClick={()=>navigate('/fornecedor/publicar')} style={{display:'inline-flex',alignItems:'center',gap:'6px'}}>
              <PlusIcon size={14}/> Publicar primeiro anúncio
            </button>
          </div>
        ) : (
          <div className="grid-3">
            {anuncios.map((a,i)=>{
              const ec = estadoCores[a.estado] || estadoCores.pendente;
              return (
                <div key={a.id} className="card" style={{padding:0,overflow:'hidden'}}>
                  {/* Imagem */}
                  <div style={{height:'120px',background:gradientes[i%gradientes.length],display:'flex',alignItems:'center',justifyContent:'center',position:'relative',overflow:'hidden'}}>
                    {a.fotos?.[0]
                      ? <img src={a.fotos[0]} alt={a.titulo} style={{width:'100%',height:'100%',objectFit:'cover'}} onError={e=>e.target.style.display='none'} />
                      : <PackageIcon size={40} color='rgba(249,115,22,0.4)'/>
                    }
                    <div style={{position:'absolute',top:'8px',right:'8px'}}>
                      <span style={{background:ec.bg,border:`1px solid ${ec.border}`,color:ec.cor,fontSize:'10px',fontWeight:'600',padding:'3px 8px',borderRadius:'20px'}}>
                        {ec.label}
                      </span>
                    </div>
                  </div>

                  <div style={{padding:'12px 14px'}}>
                    <div style={{fontSize:'13px',fontWeight:'600',marginBottom:'2px',color:'var(--text-primary)',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{a.titulo}</div>
                    <div style={{fontSize:'11px',color:'var(--text-muted)',marginBottom:'8px'}}>{a.categoria_icone} {a.categoria_nome||'—'}</div>

                    <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:'10px',paddingBottom:'10px',borderTop:'1px solid var(--border)',paddingTop:'10px'}}>
                      <div style={{fontSize:'14px',fontWeight:'700',color:'var(--orange)'}}>{parseFloat(a.preco_dia).toLocaleString()} Kz<span style={{fontSize:'10px',fontWeight:'400',color:'var(--text-muted)'}}>/dia</span></div>
                      <div style={{display:'flex',gap:'10px',alignItems:'center'}}>
                        <span style={{fontSize:'11px',color:'var(--text-muted)',display:'flex',alignItems:'center',gap:'3px'}}><EyeIcon size={11}/> {a.total_views||0}</span>
                        <span style={{fontSize:'11px',color:'var(--text-muted)',display:'flex',alignItems:'center',gap:'3px'}}><ReceiptIcon size={11}/> {a.total_reservas||0}</span>
                      </div>
                    </div>

                    <div style={{display:'flex',gap:'6px'}}>
                      <button className="btn btn-outline btn-sm" style={{flex:1,justifyContent:'center',fontSize:'11px',display:'flex',alignItems:'center',gap:'4px'}}
                        onClick={()=>navigate(`/fornecedor/publicar?editar=${a.id}`)}>
                        <EditIcon size={11}/> Editar
                      </button>
                      {a.estado === 'ativo' && (
                        <button className="btn btn-ghost btn-sm" style={{flex:1,justifyContent:'center',fontSize:'11px',display:'flex',alignItems:'center',gap:'4px'}}
                          onClick={()=>alterarEstado(a.id,'pausado')}>
                          <PauseIcon size={11}/> Pausar
                        </button>
                      )}
                      {a.estado === 'pausado' && (
                        <button className="btn btn-success btn-sm" style={{flex:1,justifyContent:'center',fontSize:'11px',display:'flex',alignItems:'center',gap:'4px'}}
                          onClick={()=>alterarEstado(a.id,'ativo')}>
                          <PlayIcon size={11}/> Activar
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}

            {/* Card novo anúncio */}
            <div className="card" style={{padding:0,overflow:'hidden',cursor:'pointer',border:'2px dashed var(--border)',background:'var(--surface)'}}
              onClick={()=>navigate('/fornecedor/publicar')}>
              <div style={{height:'120px',background:'transparent',display:'flex',alignItems:'center',justifyContent:'center'}}>
                <PlusIcon size={28} color='var(--text-muted)'/>
              </div>
              <div style={{padding:'12px 14px'}}>
                <div style={{fontSize:'13px',fontWeight:'600',color:'var(--text-muted)',marginBottom:'2px'}}>Publicar novo anúncio</div>
                <div style={{fontSize:'11px',color:'var(--text-muted)'}}>Clica para começar</div>
                <div style={{marginTop:'10px',paddingTop:'10px',borderTop:'1px solid var(--border)'}}>
                  <span style={{fontSize:'11px',color:'var(--orange)',fontWeight:'500'}}>Criar agora →</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
